import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { Subscription } from 'rxjs';
import { ToastService } from '@services/toast.service';

interface ToastItem {
  id: number;
  message: string;
}

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
})
export class ToastComponent implements OnInit, OnDestroy {
  private toastService = inject(ToastService);

  toasts: ToastItem[] = [];
  private subscription?: Subscription;
  private nextId = 0;

  ngOnInit(): void {
    this.subscription = this.toastService.toast$.subscribe((message) => {
      this.toasts.push({ id: this.nextId++, message });
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  close(id: number): void {
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
  }
}
